module.exports = __webpack_public_path__ + "487e9785b66e13cd44fa88569f350eec.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/glasses-hipster-s.png
// module id = 1825
// module chunks = 0